import { GROW_GUIDE_FREE_COMPONENT } from 'navigation-components/config';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { useCallback } from 'react';
import { GlobalToolbarButton, ICON_NAMES } from '../../../components/GlobalToolbar/Components';
import { jsx as _jsx } from "react/jsx-runtime";
export const GrowGuideButton = () => {
  const {
    toggle
  } = useToggleComponent(GROW_GUIDE_FREE_COMPONENT);
  const handleToggle = useCallback(() => {
    toggle();
  }, [toggle]);
  return /*#__PURE__*/_jsx(GlobalToolbarButton, {
    "data-test-id": "grow-guide-button",
    id: "grow-guide-button",
    itemName: "Grow Guide",
    iconName: ICON_NAMES.GROW_GUIDE,
    onClick: handleToggle,
    ariaLabelKey: "nav.icons.growGuide",
    iconTitleKey: "nav.icons.growGuide"
  });
};